import { render } from "./WelcomeUser.vue?vue&type=template&id=229b7e86&ts=true"
import script from "./WelcomeUser.vue?vue&type=script&lang=ts"
export * from "./WelcomeUser.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__